// extracted by mini-css-extract-plugin
module.exports = {"noBold":"product-category-tree-details_noBold_zCKD5","group":"product-category-tree-details_group_3w225","levels":"product-category-tree-details_levels_21h-u"};